<template>
  <PSAreaUser />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
